export interface CoreStripePaymentNotice {
  titleKey: 'website.pricing.paymentFailedTitle' | 'website.pricing.paymentPendingTitle';
  descriptionKey: 'website.pricing.paymentFailedDescription' | 'website.pricing.paymentPendingDescription';
  portalActionKey: 'website.pricing.updatePaymentMethod' | 'website.pricing.editBilling';
}

const normalizeProviderToken = (provider?: string | null) =>
  String(provider || '')
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, '');

export const resolveCoreStripePaymentNotice = ({
  provider,
  status,
  requiresPaymentMethodUpdate,
}: {
  provider?: string | null;
  status?: string | null;
  requiresPaymentMethodUpdate?: boolean | null;
}): CoreStripePaymentNotice | null => {
  if (normalizeProviderToken(provider) !== 'stripe') return null;

  if (status === 'payment_failed') {
    return {
      titleKey: 'website.pricing.paymentFailedTitle',
      descriptionKey: 'website.pricing.paymentFailedDescription',
      portalActionKey: requiresPaymentMethodUpdate
        ? 'website.pricing.updatePaymentMethod'
        : 'website.pricing.editBilling',
    };
  }

  if (status === 'payment_pending') {
    return {
      titleKey: 'website.pricing.paymentPendingTitle',
      descriptionKey: 'website.pricing.paymentPendingDescription',
      portalActionKey: 'website.pricing.editBilling',
    };
  }

  return null;
};
